import React from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import DescriptionIcon from '@material-ui/icons/Description'
import HelpIcon from '@material-ui/icons/Help'
import BusinessIcon from '@material-ui/icons/Business'
import InfoIcon from '@material-ui/icons/Info'
import { useNavigate } from 'react-router-dom'
import { Links } from '../../../../settings/links'

export const MenuUniversal: React.FC = (): React.ReactElement => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  /**
   * Opens external link in a new window
   */
  const openLink = (link: string) => {
    window.open(link)
  }

  /**
   * Navigates to the about page
   */
  const toAbout = () => {
    navigate('/about')
  }
  const menuItems = [
    { label: t('footer.terms'), onClick: () => openLink(Links.terms), icon: <DescriptionIcon /> },
    { label: t('footer.help'), onClick: () => openLink(Links.help), icon: <HelpIcon /> },
    { label: t('footer.nonProfitRegister'), onClick: () => openLink(Links.charities), icon: <BusinessIcon /> },
    { label: t('footer.about'), onClick: toAbout, icon: <InfoIcon /> },
  ]

  return (
    <List>
      {menuItems.map((item, index) => (
        <ListItem key={index} button onClick={item.onClick}>
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText>{item.label}</ListItemText>
        </ListItem>
      ))}
    </List>
  )
}
